import { useRecordContext } from 'react-admin';
import { Link } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import Button from '@mui/material/Button';

import { useClaimReimbursement } from '@pumpkincare/claims';
import { BankWithdrawal, TabPanel } from '@pumpkincare/shared';
import { useCareCreditDetails } from '@pumpkincare/users';

import RoutePaths from '../../../routes';
import { claimReimbursementTabStyle } from './claim-reimbursement-tab-style';

export default function ClaimReimbursementTab({ tabValue }) {
  const classes = claimReimbursementTabStyle();

  const claimRecord = useRecordContext();

  const { data: reimbursementData = [], isReimbursementDataLoading } =
    useClaimReimbursement(claimRecord?.id);

  const shouldFetchCareCreditDetails =
    !isReimbursementDataLoading &&
    reimbursementData?.some(
      reimbursement => reimbursement.reimbursement_method === 'CARE_CREDIT'
    );
  const { data: careCreditData, isLoading: isCareCreditDataLoading } =
    useCareCreditDetails(claimRecord?.customer_id, shouldFetchCareCreditDetails);

  return (
    <TabPanel value={tabValue} index={2}>
      {isReimbursementDataLoading || isCareCreditDataLoading ? (
        <CircularProgress />
      ) : (
        <>
          {reimbursementData?.map((reimbursement, index) => {
            return (
              <div key={index} className={classes.reimbursementContainer}>
                <BankWithdrawal
                  reimbursement={reimbursement}
                  careCreditData={careCreditData}
                />
              </div>
            );
          })}
        </>
      )}
      {reimbursementData?.length > 0 ? (
        <div style={{ marginTop: '68px' }}>
          <Button
            variant='outlined'
            fullWidth
            style={{
              textTransform: 'none',
              backgroundColor: '#007DFF',
              color: '#FFFFFF',
            }}
            component={Link}
            to={{
              pathname: `/${RoutePaths.reimbursements}/${claimRecord.id}/show`,
            }}
          >
            REIMBURSEMENT DETAILS
          </Button>
        </div>
      ) : null}
    </TabPanel>
  );
}
